import { useEffect, useState } from 'react';

/**
 * Gates a boolean behind a delay so brief truthy blips never surface. Used for
 * loading spinners/skeletons: only report loading once it has persisted past
 * `delayMs`, so fast responses resolve before anything is shown and no flash
 * occurs. Turning off is immediate. A change of `resetKey` restarts the delay
 * even while `active` stays true, so one subject's elapsed wait never carries
 * over to the next (e.g. switching sessions mid-restore).
 */
export function useDelayedFlag(
  active: boolean,
  delayMs = 200,
  resetKey?: unknown
): boolean {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    setShown(false);
    if (!active) return;
    const timer = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs, resetKey]);

  return active && shown;
}
